import { domain } from './utils';

// Service reset
export const reset = domain.event<void>();
